import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiFileText, FiTarget } = FiIcons;

const WordCounter = ({ count, target = 1500 }) => {
  const percentage = Math.min((count / target) * 100, 100);
  const isOptimal = count >= 1000 && count <= 1500;
  const isUnder = count < 1000;
  const isOver = count > 1500;

  const getStatusColor = () => {
    if (isOptimal) return 'text-green-600';
    if (isUnder) return 'text-yellow-600';
    return 'text-red-600';
  };

  const getProgressColor = () => {
    if (isOptimal) return 'bg-green-500';
    if (isUnder) return 'bg-yellow-500';
    return 'bg-red-500';
  };

  const getStatusText = () => {
    if (isOptimal) return 'Optimal length';
    if (isUnder) return 'Too short for SEO';
    return 'Consider shortening';
  };

  return (
    <div className="bg-gray-50 rounded-lg p-4">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center space-x-2">
          <SafeIcon icon={FiFileText} className="text-lg text-gray-600" />
          <span className="font-medium text-gray-900">Word Count</span>
        </div>
        <div className="flex items-center space-x-2">
          <SafeIcon icon={FiTarget} className="text-sm text-gray-500" />
          <span className="text-sm text-gray-500">Target: 1000-1500</span>
        </div>
      </div>

      <div className="flex items-center justify-between mb-2">
        <span className={`text-2xl font-bold ${getStatusColor()}`}>
          {count.toLocaleString()}
        </span>
        <span className={`text-sm font-medium ${getStatusColor()}`}>
          {getStatusText()}
        </span>
      </div>

      <div className="w-full bg-gray-200 rounded-full h-2">
        <div
          className={`h-2 rounded-full transition-all duration-300 ${getProgressColor()}`}
          style={{ width: `${percentage}%` }}
        />
      </div>

      <div className="flex justify-between text-xs text-gray-500 mt-1">
        <span>0</span>
        <span>1000</span>
        <span>1500</span>
      </div>
    </div>
  );
};

export default WordCounter;